import React from 'react';
import * as S from './ConversionRateReportCardLabel.styled';
export const ConversionRateReportCardLabel = ({ label, sessionsNumber, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Label, null, label),
        React.createElement(S.Sublabel, null,
            sessionsNumber,
            " sessions")));
};
